import React, { useState, useEffect } from 'react'
import classes from './DataUpload.module.css'
import Loader from '../Loader'
import axios from '../../Axios'
import Axios from 'axios'
import { Urls } from '../../Urls'
import { toast } from 'react-toastify'
import { logActivity } from '../Utilities'
const DataUpload = () => {
    const [isLoading, setisLoading] = useState(false)
    const [branchData, setbranchData] = useState({})
    const [isBranchDataUploaded, setisBranchDataUploaded] = useState(false)
    const [isLaneDataUploaded, setisLaneDataUploaded] = useState(false)
    const [laneData, setlaneData] = useState({})


    useEffect(() => {
        // logActivity([
        //     {
        //         'screen': 'Data Upload',
        //         'module': 'Data Upload',
        //         'user_activity': 'Page Viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
    }, [])

    const fileHandler = event => {
        const fileType = event.target.name
        const fileToUpload = event.target.files[0]
        setData(fileType, fileToUpload)
    }

    const setData = (fileType = 'branch-data', fileToUpload) => {
        switch (fileType) {
            case 'branch-data':
                document.getElementById('upload-branch-data').style.display = 'block'
                document.getElementById('dump-branch-data').style.display = 'block'
                setbranchData({
                    'fileData': fileToUpload,
                    'fileUrl': ''
                })
                break
            case 'lane-data':
                document.getElementById('upload-lane-data').style.display = 'block'
                document.getElementById('dump-lane-data').style.display = 'block'
                setlaneData({
                    'fileData': fileToUpload,
                    'fileUrl': ''
                })
                break
        }
    }

    const uploadFile = (dataType) => {
        let body
        console.log(dataType)
        switch (dataType) {
            case 'branch-data':
                console.log(branchData)
                setisLoading(true)
                body = {
                    'action': 'upload',
                    'fileName': branchData['fileData']['name'],
                    'accountName': 'lnclientdata',
                    'containerName': 'dcrawfile'
                }
                Axios.post(Urls.fileService, body)
                    .then(res => {
                        // console.log(res.data)
                        const fileUrl = res.data.url
                        const blobHeaders = {
                            'x-ms-blob-type': 'blockblob',
                            'x-ms-blob-content-type': branchData['fileData']['type'] ? branchData['fileData']['type'] : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'Content-Type': branchData['fileData']['type'] ? branchData['fileData']['type'] : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'x-ms-content-disposition': branchData['fileData']['name'] ? branchData['fileData']['name'] : `branch-data#${localStorage.getItem('userid')}.xlsx`
                        }
                        Axios.put(fileUrl, branchData['fileData'], { headers: blobHeaders })
                            .then(res => {
                                // console.log(res.data)
                                toast.success('File has been uploaded successfully!')
                                setbranchData({ ...branchData, fileUrl: fileUrl })
                                setisBranchDataUploaded(true)
                                setisLoading(false)
                            })
                            .catch(err => {
                                console.log(err)
                                setisLoading(false)
                                toast.error('Error while uploading your file :(')
                            })
                    })
                    .catch(err => {
                        console.log(err)
                        setisLoading(false)
                        toast.error('Error while uploading your file :(')
                    })
                break;
            case 'lane-data':
                console.log(laneData)
                setisLoading(true)
                body = {
                    'action': 'upload',
                    'fileName': laneData['fileData']['name'],
                    'accountName': 'lnclientdata',
                    'containerName': 'dcrawfile'
                }
                Axios.post(Urls.fileService, body)
                    .then(res => {
                        // console.log(res.data)
                        const fileUrl = res.data.url
                        const blobHeaders = {
                            'x-ms-blob-type': 'blockblob',
                            'x-ms-blob-content-type': laneData['fileData']['type'] ? laneData['fileData']['type'] : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'Content-Type': laneData['fileData']['type'] ? laneData['type'] : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'x-ms-content-disposition': laneData['fileData']['name'] ? laneData['fileData']['name'] : `lane-data#${localStorage.getItem('userid')}.xlsx`
                        }
                        Axios.put(fileUrl, laneData['fileData'], { headers: blobHeaders })
                            .then(res => {
                                // console.log(res.data)
                                toast.success('File has been uploaded successfully!')
                                setisLaneDataUploaded(true)
                                setlaneData({ ...laneData, fileUrl: fileUrl })
                                setisLoading(false)
                            })
                            .catch(err => {
                                console.log(err)
                                toast.error('Error while uploading your file :(')
                                setisLoading(false)
                            })
                    })
                    .catch(err => {
                        console.log(err)
                        toast.error('Error while uploading your file :(')
                        setisLoading(false)
                    })
                break;
        }
    }

    const dumpFile = (fileType) => {
        const data = {
            'key': fileType,
            'userid': localStorage.getItem('userid'),
            'file': fileType === 'branch' ? branchData['fileData']['name'] : laneData['fileData']['name']
        }
        if (data['file']) {
            setisLoading(true)
            Axios.post(Urls.database.dump, data)
                .then(res => {
                    toast.success('File has been dumped to the database!')
                    setisLoading(false)
                })
                .catch(err => {
                    console.log(err)
                    setisLoading(false)
                    toast.error('Error while dumping your file to the database')
                })
        }
        else {
            toast.error('No file url found')
        }
    }

    return (
        <>
            <Loader isLoading={isLoading} />
            <div style={{ opacity: isLoading ? '0.2' : '1' }} className={classes['container']}>
                <div className={classes['upload-container']}>
                    <div className={classes['branch-uploader']}>
                        <div className={classes['file-input-container']}>
                            <div className={'form-group'}>
                                <label className={classes['upload-title']}>Please select a branch file to upload</label>
                                <input name='branch-data' onChange={fileHandler} style={{ margin: '0 auto' }} type='file' className={'form-control'} />
                            </div>
                        </div>
                        <div className={classes['file-upload-button-container']}>
                            <div className={'row'}>
                                <div className={'form-group col-6'}>
                                    <button onClick={() => uploadFile('branch-data')} id='upload-branch-data' style={{ width: '100%', display: 'none', transition: '1.0s' }} className={'btn btn-primary'} >Upload</button>
                                </div>
                                <div className={'form-group col-6'}>
                                    <button onClick={() => dumpFile('branch')} id='dump-branch-data' style={{ width: '100%', display: 'none', transition: '1.0s' }} className={'btn btn-success'} >Dump to Database</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes['lane-uploader']}>
                        <div className={classes['file-input-container']}>
                            <div className={'form-group'}>
                                <label className={classes['upload-title']}>Please select a lane file to upload</label>
                                <input name='lane-data' onChange={fileHandler} style={{ margin: '0 auto' }} type='file' className={'form-control'} />
                            </div>
                        </div>
                        <div className={classes['file-upload-button-container']}>
                            <div className={'row'}>
                                <div className={'form-group col-6'}>
                                    <button onClick={() => uploadFile('lane-data')} id='upload-lane-data' style={{ width: '100%', display: 'none', transition: '1.0s' }} className={'btn btn-primary'} >Upload</button>
                                </div>
                                <div className={'form-group col-6'}>
                                    <button onClick={() => dumpFile('lane')} id='dump-lane-data' style={{ width: '100%', display: 'none', transition: '1.0s' }} className={'btn btn-success'} >Dump to Database</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DataUpload
